import styled from 'styled-components'
import { Input, InputNumber } from 'antd'

export const StyledDHSManualUpdateLoadingContainer = styled.div`
  padding: 24px;
  background: #fff;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ReadOnlyInput = styled(Input)`
  cursor: not-allowed;

  &.ant-input[readonly] {
    cursor: not-allowed;
  }
`;

export const ReadOnlyInputNumber = styled(InputNumber)`
  cursor: not-allowed;

  .ant-input-number-input {
    cursor: not-allowed;
  }
`;